import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "#components/atoms/Input/Input";

type MaterialNameCellProps = {
  value: string;
  onUpdate: (value: string) => void;
};

export const MaterialNameCell = ({ value, onUpdate }: MaterialNameCellProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <Input
      value={inputValue}
      onChange={setInputValue}
      onBlur={() => {
        if (inputValue !== value) {
          onUpdate(inputValue);
        }
      }}
      aria-label={t("onboardingV2.rawMaterialSpecification.columns.materialName")}
    />
  );
};
